import module from 'kendu/legacy/module'

export class ResponsiveService {
  constructor ($window) {
    this.$window = $window
    this.breakpoints = {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    }
  }

  test (layout) {
    let ww = this.$window.innerWidth
    let bp = this.breakpoints

    switch (layout) {
      case 'xs':
        return ww <= bp.xs
      case 'gt-xs':
        return ww > bp.xs
      case 'sm':
        return ww > bp.xs && ww <= bp.sm
      case 'gt-sm':
        return ww > bp.sm
      case 'md':
        return ww > bp.sm && ww <= bp.md
      case 'gt-md':
        return ww > bp.md
      case 'lg':
        return ww > bp.md && ww <= bp.lg
      case 'gt-lg':
        return ww > bp.lg
      case 'xl':
        return ww > bp.lg
      default:
        return false
    }
  }
}

module.service('$responsive', ResponsiveService)



// WEBPACK FOOTER //
// ./src/deprecated/services/$responsive.js